import { default as theme } from './default'
import { default as fall } from './fall'

export default { default: theme, fall }
